import { lazy } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const LazyBrandValuesSection = lazy(() =>
  import("./BrandValuesSection")
    .then((m) => ({ default: m.BrandValuesSection }))
    .catch(handleComponentLoadError)
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyBrandValuesSection.displayName = "LazyBrandValuesSection";
